namespace Matrix.Data {
    export interface OwnershipBasisForm {
        OwnershipBasisCode: Serenity.StringEditor;
        Name: Serenity.StringEditor;
        CreatedBy: StaticTextBlock;
        CreatedWhen: ReadOnlyDateTime;
        UpdatedBy: StaticTextBlock;
        UpdatedWhen: ReadOnlyDateTime;
        Version: StaticTextBlock;
    }

    export class OwnershipBasisForm extends Serenity.PrefixedContext {
        static formKey = 'Data.OwnershipBasis';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!OwnershipBasisForm.init)  {
                OwnershipBasisForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = StaticTextBlock;
                var w2 = ReadOnlyDateTime;

                Q.initFormType(OwnershipBasisForm, [
                    'OwnershipBasisCode', w0,
                    'Name', w0,
                    'CreatedBy', w1,
                    'CreatedWhen', w2,
                    'UpdatedBy', w1,
                    'UpdatedWhen', w2,
                    'Version', w1
                ]);
            }
        }
    }
}
